<template>
  <div class="channel-compare">
    <div class="channel-box">
      <p>推荐渠道</p>
      <div class="flex-wrap bar-wrap">
        <HorizontalBar
          class="bar"
          height="420"
          title="Leads数、上门量、新签人数"
          :show-keys="barKeys1"
          :query-data.sync="queryData"
        />
        <HorizontalBar
          class="bar"
          height="420"
          title="新签总额"
          :show-keys="barKeys2"
          :query-data.sync="queryData"
        />
      </div>
    </div>
    <div class="channel-box">
      <p>在线渠道</p>
      <div class="flex-wrap bar-wrap">
        <HorizontalBar
          class="bar"
          height="420"
          title="Leads数、上门量、新签人数"
          :show-keys="barKeys3"
          :query-data.sync="queryData"
        />
        <HorizontalBar
          class="bar"
          height="420"
          title="新签总额"
          :show-keys="barKeys4"
          :query-data.sync="queryData"
        />
      </div>
    </div>
    <div class="channel-box">
      <p>呼入渠道</p>
      <div class="flex-wrap bar-wrap">
        <HorizontalBar
          class="bar"
          height="420"
          title="Leads数、上门量、新签人数"
          :show-keys="barKeys5"
          :query-data.sync="queryData"
        />
        <HorizontalBar
          class="bar"
          height="420"
          title="新签总额"
          :show-keys="barKeys6"
          :query-data.sync="queryData"
        />
      </div>
    </div>
    <div class="channel-box">
      <p>拉访渠道</p>
      <div class="flex-wrap bar-wrap">
        <HorizontalBar
          class="bar"
          height="420"
          title="Leads数、上门量、新签人数"
          :show-keys="barKeys7"
          :query-data.sync="queryData"
        />
        <HorizontalBar
          class="bar"
          height="420"
          title="新签总额"
          :show-keys="barKeys8"
          :query-data.sync="queryData"
        />
      </div>
    </div>
    <div class="channel-box">
      <p>直访渠道</p>
      <div class="flex-wrap bar-wrap">
        <HorizontalBar
          class="bar"
          height="420"
          title="Leads数、上门量、新签人数"
          :show-keys="barKeys9"
          :query-data.sync="queryData"
        />
        <HorizontalBar
          class="bar"
          height="420"
          title="新签总额"
          :show-keys="barKeys10"
          :query-data.sync="queryData"
        />
      </div>
    </div>
    <div class="channel-box">
      <p>其他渠道</p>
      <div class="flex-wrap bar-wrap">
        <HorizontalBar
          class="bar"
          height="420"
          title="Leads数、上门量、新签人数"
          :show-keys="barKeys11"
          :query-data.sync="queryData"
        />
        <HorizontalBar
          class="bar"
          height="420"
          title="新签总额"
          :show-keys="barKeys12"
          :query-data.sync="queryData"
        />
      </div>
    </div>
  </div>
</template>

<script>
import HorizontalBar from '@/components/chart/HorizontalBar.vue'
export default {
  name: 'ChannelCompare',
  components: {
    HorizontalBar
  },
  props: {
    dataInfo: Array
  },
  data() {
    return {
      queryData: [],
      barKeys1: [
        { key: 'C7', name: '新签人数', color: '#4c84ff' },
        { key: 'B11', name: '上门量', color: '#34c6ac' },
        { key: 'A10', name: 'Leads数', color: '#ffb34c' }
      ],
      barKeys2: [{ key: 'D7', name: '新签总额', color: '#4c84ff' }],
      barKeys3: [
        { key: 'C8', name: '新签人数', color: '#4c84ff' },
        { key: 'B12', name: '上门量', color: '#34c6ac' },
        { key: 'A11', name: 'Leads数', color: '#ffb34c' }
      ],
      barKeys4: [{ key: 'D8', name: '新签总额', color: '#4c84ff' }],
      barKeys5: [
        { key: 'C9', name: '新签人数', color: '#4c84ff' },
        { key: 'B13', name: '上门量', color: '#34c6ac' },
        { key: 'A12', name: 'Leads数', color: '#ffb34c' }
      ],
      barKeys6: [{ key: 'D9', name: '新签总额', color: '#4c84ff' }],
      barKeys7: [
        { key: 'C10', name: '新签人数', color: '#4c84ff' },
        { key: 'B14', name: '上门量', color: '#34c6ac' },
        { key: 'A13', name: 'Leads数', color: '#ffb34c' }
      ],
      barKeys8: [{ key: 'D10', name: '新签总额', color: '#4c84ff' }],
      barKeys9: [
        { key: 'C11', name: '新签人数', color: '#4c84ff' },
        { key: 'B15', name: '上门量', color: '#34c6ac' },
        { key: 'A14', name: 'Leads数', color: '#ffb34c' }
      ],
      barKeys10: [{ key: 'D11', name: '新签总额', color: '#4c84ff' }],
      barKeys11: [
        { key: 'C12', name: '新签人数', color: '#4c84ff' },
        { key: 'B16', name: '上门量', color: '#34c6ac' },
        { key: 'A15', name: 'Leads数', color: '#ffb34c' }
      ],
      barKeys12: [{ key: 'D12', name: '新签总额', color: '#4c84ff' }]
    }
  },
  watch: {
    dataInfo(val) {
      this.queryData = val.slice(1)
    }
  },
  created() {
    this.queryData = this.dataInfo.slice(1)
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
.channel-compare {
  .channel-box {
    margin-bottom: 30px;
    p {
      color: $color_black;
      font-size: 30px;
    }
    .bar-wrap {
      flex-wrap: wrap;
      justify-content: space-between;
      .bar {
        margin-top: 40px;
        width: 760px;
      }
    }
  }
}
</style>
